import {Button, Crown, Modal, ModalProps} from '@blesk-frontend/ui';
import {Link} from '@tanstack/react-router';

interface PlanPaywallModalProps extends ModalProps {}

export const PlanPaywallModal = ({...rest}: PlanPaywallModalProps) => (
  <Modal {...rest}>
    <div className="mb-6 flex flex-col items-start gap-2 text-title-h1">
      <div className="rounded-md bg-brand-primary p-2">
        <Crown className="size-6 flex-1 text-attention-primary" />
      </div>
      <h1 className="text-title-h1">
        Откройте доступ
        <br />к возможностям Блеска
      </h1>
    </div>
    <div className="mb-6 text-paragraph-md text-text-secondary">
      Подключите один из расширенных тарифов, чтобы максимально удобно создавать и работать
      с&nbsp;пошаговыми инструкциями.
      <br />
      <br />С подпиской будет доступно:
      <ul className="list-disc pl-6">
        <li>создание любого количества инструкций</li>
        <li>командная работа над инструкциями</li>
        <li>создание коллекций с инструкциями</li>
      </ul>
    </div>
    <Link to="/plans">
      <Button
        type="button"
        onClick={rest.onClose}
        className="border-none bg-brand-primary hover:bg-brand-primary/90"
      >
        Перейти к тарифам
      </Button>
    </Link>
  </Modal>
);
